import { isDev, isLocal, isProd } from "../constants";

import { type BannerConfig } from "./BannerConfig";

const verifyBannerConfig = (bannerConfigParsed: unknown): bannerConfigParsed is BannerConfig => {
    return (
        typeof bannerConfigParsed === "object" &&
        bannerConfigParsed !== null &&
        "titleText" in bannerConfigParsed &&
        "subtitleText" in bannerConfigParsed &&
        "ctaText" in bannerConfigParsed &&
        "ctaURL" in bannerConfigParsed &&
        "expiryDate" in bannerConfigParsed &&
        typeof bannerConfigParsed.titleText === "string" &&
        typeof bannerConfigParsed.subtitleText === "string" &&
        typeof bannerConfigParsed.ctaText === "string" &&
        typeof bannerConfigParsed.ctaURL === "string" &&
        typeof bannerConfigParsed.expiryDate === "string" &&
        ("openInNewTab" in bannerConfigParsed ? typeof bannerConfigParsed.openInNewTab === "boolean" : true)
    );
};

export const parseBannerConfig = (bannerConfig: string): BannerConfig | null => {
    try {
        let bannerConfigDoubleQuotes = bannerConfig;

        if (isLocal() || isDev()) {
            // local storage overrides uses single quotes
            // but JSON.parse needs double quotes
            bannerConfigDoubleQuotes = bannerConfig.replaceAll("'", '"');
        }

        const parsedBannerConfig = JSON.parse(bannerConfigDoubleQuotes) as unknown;

        return verifyBannerConfig(parsedBannerConfig) ? parsedBannerConfig : null;
    } catch (error) {
        if (!isProd()) {
            console.error(error);
        }
        return null;
    }
};
